import React, { useEffect } from 'react';
import classNames from 'classnames';

const Wrapper = SvgComponent => {
  return React.forwardRef((props, ref) => {
    const { stabilize = true, className } = props;
    useEffect(() => {
      if (stabilize && typeof stabilizeSVG === 'function') {
        setTimeout(() => {
          if (ref?.current) {
            stabilizeSVG(ref.current);
          }
        });
      }
    }, [stabilize, ref]);

    return (
      <SvgComponent
        className={classNames('StreamlineIcon', className)}
        ref={ref}
        {...props}
      />
    );
  });
};

export default Wrapper;
